import KpiCard from './KpiCard.jsx';
import { formatAnalyticsNumber } from '../utils/format-number.js';

/** Grilla KPI: value null → "Sin datos". */
export default function KpiGrid({ items, loading }) {
  const list = Array.isArray(items) ? items : [];
  if (loading) {
    return (
      <div className="analytics-kpi-grid" aria-busy="true">
        {Array.from({ length: Math.min(list.length || 4, 8) }).map((_, i) => (
          <div key={i} className="shared-kpi-card shared-kpi-skeleton" />
        ))}
      </div>
    );
  }
  return (
    <div className="analytics-kpi-grid">
      {list.map((k) => (
        <KpiCard
          key={k.id || k.label}
          label={k.label}
          value={
            k.value == null || k.value === ''
              ? 'Sin datos'
              : formatAnalyticsNumber(k.value)
          }
          hint={k.hint || (k.value == null ? 'Fuente no conectada' : undefined)}
          tone={k.value == null ? undefined : k.tone}
        />
      ))}
    </div>
  );
}
